import { STATIC_ROUTES } from "arv-extends/constants";

STATIC_ROUTES.NEW.push("corporate-gifting");
STATIC_ROUTES.NEW.push("circle");

export default STATIC_ROUTES;
